export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';
export const SET_DEPARTMENT = 'SET_DEPARTMENT';
export const ADD_DEPARTMENT = 'ADD_DEPARTMENT';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const REMOVE_DEPARTMENT = 'REMOVE_DEPARTMENT';
export const CLEAR_DEPARTMENT = 'CLEAR_DEPARTMENT';
export const CLEAR_DEPARTMENTS = 'CLEAR_DEPARTMENTS';
